import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BaseComponent } from '../../base/base.component';
import { ToolbarEventManagerHelper } from './../../../services/event-managers/toolbar-event-manager.helper';

@Component({
  selector: 'app-do-export-pdf',
  templateUrl: './do-export-pdf.component.html',
  styleUrl: './do-export-pdf.component.scss',
  standalone: false,
})
export class DoExportPdfComponent extends BaseComponent {
  menuItems: MenuItem[] = [];

  constructor(private toolbarEventManagerHelper: ToolbarEventManagerHelper) {
    super();
    this.menuItems = [
      {
        label: 'Export Items',
        command: () => this.onExportPdf(),
      },
      {
        label: 'Export Test Steps',
        command: () => this.onExportTestStepsPdf(),
      },
    ];
  }

  public onExportPdf(): void {
    this.toolbarEventManagerHelper.DoToolbarExportPdf = true;
  }

  public onExportTestStepsPdf(): void {
    this.toolbarEventManagerHelper.DoToolbarExportTestStepPdf = true;
  }
}
